import React, { useState } from 'react';

const CalcularPoblacion = () => {
  // Datos de ejemplo
  const citas = [
    { id: 1, riesgo: 'Alto', doctor: 'Matias Garribia', modalidad: 'Presencial' },
    { id: 2, riesgo: 'Alto', doctor: 'Maria Herminia Cesca', modalidad: 'Presencial' },
    { id: 3, riesgo: 'Intermedio', doctor: 'Matias Garribia', modalidad: 'Presencial' },
    { id: 4, riesgo: 'Intermedio', doctor: 'Maria Herminia Cesca', modalidad: 'Presencial' },
    { id: 5, riesgo: 'Intermedio-Bajo', doctor: 'Matias Garribia', modalidad: 'Presencial' },
    { id: 6, riesgo: 'Intermedio-Bajo', doctor: 'Maria Herminia Cesca', modalidad: 'Presencial' },
    { id: 7, riesgo: 'Bajo', doctor: 'Nestor Garcia', modalidad: 'Virtual' },
    { id: 8, riesgo: 'Muy Bajo', doctor: 'Nestor Garcia', modalidad: 'Virtual' },
  ];

  // Estados para el selector de riesgo
  const [selectedRiesgo, setSelectedRiesgo] = useState('');
  
  // Opciones del selector de riesgo
  const opcionesRiesgo = [
    { value: '', label: 'Sin riesgo seleccionado' },
    { value: 'Alto', label: 'Alto' },
    { value: 'Intermedio', label: 'Intermedio' },
    { value: 'Intermedio-Bajo', label: 'Intermedio-Bajo' },
    { value: 'Bajo', label: 'Bajo' },
    { value: 'Muy Bajo', label: 'Muy Bajo' },
  ];

  // Filtrar citas según el riesgo seleccionado
  const citasFiltradas = selectedRiesgo
    ? citas.filter(cita => cita.riesgo === selectedRiesgo)
    : [];

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Personal médico disponible para el seguimiento de pacientes</h2>
      
      {/* Selector de riesgo */}
      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-end' }}>
        <div style={{ width: '250px' }}>
          <label htmlFor="riesgo-selector" style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
            Filtrar por nivel de riesgo:
          </label>
          <select
            id="riesgo-selector"
            value={selectedRiesgo}
            onChange={(e) => setSelectedRiesgo(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '4px',
              border: '1px solid #ddd',
              fontSize: '14px',
              backgroundColor: 'white',
              cursor: 'pointer'
            }}
          >
            {opcionesRiesgo.map((opcion) => (
              <option key={opcion.value} value={opcion.value}>
                {opcion.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <div style={{ overflowX: 'auto', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', borderRadius: '8px' }}>
        <table style={{ 
          width: '100%', 
          borderCollapse: 'collapse',
          backgroundColor: 'white',
          borderRadius: '8px',
          overflow: 'hidden'
        }}>
          <thead>
            <tr>
              <th style={{ 
                padding: '14px', 
                textAlign: 'left', 
                backgroundColor: '#4a90e2',
                color: 'white',
                fontWeight: '500',
                fontSize: '15px'
              }}>Riesgo</th>
              <th style={{ 
                padding: '14px', 
                textAlign: 'left', 
                backgroundColor: '#4a90e2',
                color: 'white',
                fontWeight: '500',
                fontSize: '15px'
              }}>Doctor</th>
              <th style={{ 
                padding: '14px', 
                textAlign: 'left', 
                backgroundColor: '#4a90e2',
                color: 'white',
                fontWeight: '500',
                fontSize: '15px'
              }}>Modalidad</th>
            </tr>
          </thead>
          <tbody>
            {selectedRiesgo && citasFiltradas.length > 0 ? (
              citasFiltradas.map((cita) => (
                <tr 
                  key={cita.id} 
                  style={{ 
                    borderBottom: '1px solid #f0f0f0',
                    backgroundColor: cita.id % 2 === 0 ? '#f9f9f9' : 'white',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = cita.id % 2 === 0 ? '#f9f9f9' : 'white'}
                >
                  <td style={{ 
                    padding: '14px',
                    color: getRiesgoColor(cita.riesgo),
                    fontWeight: '500'
                  }}>
                    {cita.riesgo}
                  </td>
                  <td style={{ padding: '14px' }}>{cita.doctor}</td>
                  <td style={{ padding: '14px' }}>
                    <span style={{
                      backgroundColor: cita.modalidad === 'Presencial' ? '#e3f2fd' : '#e8f5e9',
                      color: cita.modalidad === 'Presencial' ? '#1976d2' : '#2e7d32',
                      padding: '4px 10px',
                      borderRadius: '12px',
                      fontSize: '13px',
                      fontWeight: '500'
                    }}>
                      {cita.modalidad}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td 
                  colSpan="3" 
                  style={{ 
                    padding: '20px', 
                    textAlign: 'center',
                    color: '#666',
                    fontStyle: 'italic'
                  }}
                >
                  {selectedRiesgo 
                    ? 'No se encontraron resultados para el riesgo seleccionado'
                    : 'Seleccione un nivel de riesgo para ver los médicos disponibles'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// Función auxiliar para obtener el color según el nivel de riesgo
const getRiesgoColor = (riesgo) => {
  switch(riesgo) {
    case 'Alto':
      return '#d32f2f'; // Rojo oscuro
    case 'Intermedio':
      return '#f57c00'; // Naranja
    case 'Intermedio-Bajo':
      return '#fbc02d'; // Amarillo oscuro
    case 'Bajo':
      return '#388e3c'; // Verde oscuro
    case 'Muy Bajo':
      return '#689f38'; // Verde más claro
    default:
      return '#333';
  }
};

export default CalcularPoblacion;
